
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 27.2c-2.55 0-4.862-.612-7.004-1.598l-2.38 2.38a1.129 1.129 0 01-1.598 0 1.129 1.129 0 010-1.598l1.904-1.904c-.17-.102-.374-.238-.544-.34-2.754-1.768-5.1-4.114-7.072-6.426-.374-.442-.374-1.088 0-1.496 2.176-2.55 5.066-5.1 8.262-6.936C11.22 7.786 14.11 6.8 17 6.8c2.346 0 4.692.646 6.902 1.7l2.516-2.516a1.129 1.129 0 011.598 0 1.129 1.129 0 010 1.598l-2.04 2.04c2.992 1.802 5.678 4.25 7.752 6.63a1.138 1.138 0 010 1.496c-1.972 2.278-4.352 4.624-7.072 6.392-2.822 1.836-6.018 3.06-9.656 3.06z","fill":"#000"}}),_c('path',{attrs:{"d":"M24.31 11.288l-1.938 1.938A6.631 6.631 0 0123.562 17c0 1.802-.714 3.468-1.938 4.658-1.19 1.19-2.822 1.904-4.658 1.904a6.55 6.55 0 01-3.774-1.19l-1.496 1.496c1.632.646 3.4 1.054 5.27 1.054 3.162 0 5.95-1.088 8.432-2.686 2.244-1.462 4.216-3.332 5.95-5.27-1.938-2.074-4.352-4.182-7.038-5.678.034 0 0 0 0 0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M20.74 14.858l-5.882 5.882c.646.374 1.36.578 2.142.578 1.19 0 2.278-.476 3.06-1.258A4.317 4.317 0 0021.318 17c0-.782-.204-1.496-.578-2.142zm-11.186 7.99l2.074-2.074A6.631 6.631 0 0110.438 17c0-1.802.748-3.434 1.938-4.624A6.5 6.5 0 0117 10.472a6.55 6.55 0 013.774 1.19l1.394-1.394C20.468 9.554 18.7 9.112 17 9.112c-2.448 0-4.998.884-7.344 2.21C7.004 12.784 4.59 14.892 2.652 17c1.734 1.904 3.706 3.808 5.95 5.27.306.204.612.374.952.578z","fill":"#fff"}}),_c('path',{attrs:{"d":"M13.26 19.142l5.882-5.882A4.212 4.212 0 0017 12.682c-1.19 0-2.278.476-3.06 1.258a4.237 4.237 0 00-1.258 3.026c0 .816.204 1.53.578 2.176z","fill":"#fff"}})])
          )
        }
      }
    